"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _constants = require("settings-ui-sdk/Ecommerce/constants");

var EcommerceStore =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(EcommerceStore, _Record);

  function EcommerceStore() {
    (0, _classCallCheck2.default)(this, EcommerceStore);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EcommerceStore).apply(this, arguments));
  }

  (0, _createClass2.default)(EcommerceStore, [{
    key: "isShopifyStore",
    get: function get() {
      return this.appId === _constants.SHOPIFY_APP_ID_PROD || this.appId === _constants.SHOPIFY_APP_ID_QA;
    }
  }]);
  return EcommerceStore;
}((0, _immutable.Record)({
  appId: null,
  id: null,
  label: null,
  adminUri: null,
  storeToken: null,
  applicationIconUrl: null
}));

exports.default = EcommerceStore;
module.exports = exports.default;